import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class VigenciaAlta extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(0, this.props.codigoNovedad, event.target.value);
    }
    /**
     * 
     */
    render() {
        let props = this.props;
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;

        errorContainer = <label className="error">
            {(errors = getFieldError('inputVigenciaAlta')) ? errors.join(',') : null}</label>

        let error = ((getFieldError('inputVigenciaAlta')) ? true : false);

        //////////Novedad en Vigencia Renovacion////////////
        let seEstaEditando = props.data.seEstaEditando;
        let VigenciaAlta = undefined;
        let novedadVigenciaAlta = undefined;
        if (props.data.novedadesEmpresaDatos != undefined) {
            novedadVigenciaAlta = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadVigenciaAlta != undefined) {
                let esNovedadEditadaVigenciaAlta = props.data.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaVigenciaAlta) {
                    VigenciaAlta = props.data.empresaDatos.VigenciaAlta;
                }
                else {
                    VigenciaAlta = novedadVigenciaAlta.ValorNovedad;
                }
            }
            else {
                VigenciaAlta = props.data.empresaDatos.VigenciaAlta;
            }
        } else {
            VigenciaAlta = props.data.empresaDatos.VigenciaAlta;
        }

        let componenteVigenciaDesdeAlta =
            <div>
                <div className="row">
                    <div className="col-xs-6">
                        <GenericInputValidate
                            getFieldProps={getFieldProps('inputVigenciaAlta', {
                                onChange(e) {
                                    me.changeInput(e);
                                },
                                rules: [{
                                    required: true,
                                    pattern: /^[1-9]+$/,
                                    message: 'Debe ingresar un valor válido.'
                                }]
                            })}
                            id="inputVigenciaAlta"
                            name="inputVigenciaAlta"
                            value={VigenciaAlta}
                            className="form-control default-input"
                            maxLength="1"
                        />
                    </div>

                    <div className="col-xs-6">
                        <label className="label-secondary"> años</label>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12">
                        {errorContainer}
                    </div>
                </div>
            </div>;

        return (
            <GenericEditPanel
                componente={componenteVigenciaDesdeAlta}
                error={error}
                permisoUsuario={props.data.funcionesDelUsuario}
                novedad={novedadVigenciaAlta}
                seEstaEditando={seEstaEditando}
                textPanel={VigenciaAlta + (VigenciaAlta > 1 ? " años" : " año") || "Sin especificar"}
                title="Vigencia desde el alta"
                value={VigenciaAlta}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadVigenciaAlta, 2, props.data.empresaDatos.Id)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadVigenciaAlta, 3, props.data.empresaDatos.Id)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
};

export default VigenciaAlta;